import { getDelays } from '../stores/national-data/delays'

export default function getDelayById(id: number) {
  const delays = getDelays()

  return delays?.find((delay) => delay.properties.InternalId === id)
}
